import type { Rule } from "eslint";
import type { Ast } from "postgresql-eslint-parser";

type Style = "always" | "never";

const DEFAULT_STYLE: Style = "always";

const rule: Rule.RuleModule = {
  meta: {
    type: "suggestion",
    docs: {
      description:
        "Enforce a consistent stance on `CONCURRENTLY` for `DROP INDEX` (either always require it, or always forbid it)",
      category: "Best Practices",
      recommended: false,
    },
    fixable: undefined,
    schema: [
      {
        type: "object",
        properties: {
          style: { enum: ["always", "never"] },
        },
        additionalProperties: false,
      },
    ],
    messages: {
      preferConcurrently:
        "Use `DROP INDEX CONCURRENTLY` to avoid an `ACCESS EXCLUSIVE` lock on the table for the entire drop.",
      unexpectedConcurrently:
        "Avoid `DROP INDEX CONCURRENTLY`. Concurrent drops cannot run inside a transaction, so they conflict with migration tools that wrap each step in BEGIN/COMMIT.",
    },
  },
  create(context) {
    const option = (context.options[0] ?? {}) as { style?: Style };
    const style: Style = option.style ?? DEFAULT_STYLE;
    return {
      DropStmt(node: Ast.DropStmt) {
        if (node.removeType !== "OBJECT_INDEX") return;
        const isConcurrent = node.concurrent === true;
        if (style === "always" && !isConcurrent) {
          context.report({
            node: node as unknown as Rule.Node,
            messageId: "preferConcurrently",
          });
          return;
        }
        if (style === "never" && isConcurrent) {
          context.report({
            node: node as unknown as Rule.Node,
            messageId: "unexpectedConcurrently",
          });
        }
      },
    };
  },
};

export default rule;
